import { v2, type PromptLibraryEntry, type PromptsListQuery } from '@/api/v2Client';

/** The service caps page size at 200. Never mistake a capped page for all results. */
export async function listAllPrompts(query: PromptsListQuery, cancelled: () => boolean = () => false): Promise<PromptLibraryEntry[]> {
  const rows: PromptLibraryEntry[] = [];
  for (let page = 1; !cancelled(); page += 1) {
    const result = await v2.prompts.list({ ...query, page, pageSize: 200 });
    if (cancelled()) return [];
    rows.push(...result.prompts);
    if (rows.length >= result.total) return rows;
    if (!result.prompts.length) throw new Error('Prompt list changed while loading. Please retry.');
  }
  return [];
}
